import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ProductService {
  constructor(private api: ApiService) { }

  getProductList(portalId: string) {
    return this.api.get(`/api/v1/portals/${portalId}/products`)
  }

  getProductDetail(params: { portalId: string, sku: string }) {
    const { portalId, sku } = params
    return this.api.get(`/api/v1/portals/${portalId}/products/${sku}`)
  }

}